// LIBRARIES
import styled from "styled-components";

// MISC
import { BOXSHADOW, COLORS, FONTS, WIDTH } from "constants/styleVariables";

export const RentStatisticsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 0 0 80px;
  @media (${WIDTH.mediumWidth}) {
    margin-top: 20px;
    margin-left: 0px;
  }
`;

export const ContainerTitle = styled.div`
  font-family: ${FONTS.montserrat};
  font-size: 20px;
  font-weight: bold;
`;

export const RentStatisticWrapper = styled.div`
  max-width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

export const RentStatisticElement = styled.div`
  width: 100%;
  height: 110px;
  margin: 20px 20px 0 0;
  background-color: ${COLORS.primaryWhite};
  border-radius: 10px;
  box-shadow: ${BOXSHADOW.containerBoxShadow};
  display: flex;
  align-items: center;
  @media (${WIDTH.tabletWidth}) {
    width: 300px;
  }
`;
